import { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { sdk } from "@farcaster/miniapp-sdk";
import Header from "./components/Header";
import WhiteListView from "./pages/Whitelist";
import MintView from "./pages/MintView";
import MintInfo from "./pages/MintInfo";
import MintCountdown from "./pages/MintCountdown";
import WarpletVerse from "./pages/WarpletVerse";
import BottomBar from "./components/BottomBar";
import "./App.css";

import { Mode } from "./enum";
import { DEMO_USER } from "./constants/demo";
import { WHITELIST_END_TIME } from "./constants/whitelist";
import { UserContext } from "./types/user";
import Intro from "./pages/Intro";
const { Verse, Whitelist, Mint, Countdown, Info } = Mode;

export default function App() {
  const [miniApp, setMiniApp] = useState(false);
  const [mode, setMode] = useState(Mint);
  const [user, setUser] = useState<UserContext>();

  const onModeChange = (newMode: Mode) => {
    setMode(newMode);
  };

  useEffect(() => {
    const initializeApp = async () => {
      if (import.meta.env.PROD) {
        const miniApp = await sdk.isInMiniApp();
        setMiniApp(miniApp);

        if (!miniApp) return;

        const user = (await sdk.context).user;
        setUser(user);
        await sdk.actions.ready();
        await sdk.actions.addMiniApp();
      } else {
        setUser(DEMO_USER);
        setMiniApp(true);
      }
    };
    initializeApp();
  }, []);

  if (!miniApp) {
    return (
      <div className="app">
        <Intro />
      </div>
    );
  }

  const renderView = () => {
    switch (mode) {
      case Whitelist:
        return <WhiteListView user={user} />;
      case Verse:
        return <WarpletVerse />;
      case Mint:
        return <MintView />;
      case Countdown:
        return <MintCountdown />;
      case Info:
        return <MintInfo />;
      default:
        return null;
    }
  };

  return (
    <div className="app">
      <Header
        user={user}
        whitelistEndTime={WHITELIST_END_TIME}
        mode={mode}
        onModeChange={onModeChange}
      />
      <Toaster position="top-center" />
      {renderView()}
      <BottomBar
        mode={mode}
        onModeChange={onModeChange}
        whitelistEndTime={WHITELIST_END_TIME}
      />
    </div>
  );
}
